import * as types from '../types/cartTypes';

const initialState = {
  data: [], // jadi array
  loading: false,
  error: null,
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_CART_ITEMS: {
      const product = action.payload;

      // cek apakah produk sudah ada di cart
      const existingItem = state.data.find((item) => item.id === product.id);

      if (existingItem) {
        // kalau sudah ada, update quantity
        return {
          ...state,
          data: state.data.map((item) =>
            item.id === product.id ? { ...item, quantity: (item.quantity || 1) + 1 } : item,
          ),
        };
      }

      // kalau belum ada, tambahkan produk baru
      return {
        ...state,
        data: [...state.data, { ...product, quantity: 1 }],
      };
    }

    case types.REMOVE_CART_ITEM: {
      const id = action.payload; // payload hanya id

      const existingItem = state.data.find((item) => item.id === id);

      if (!existingItem) return state;

      if (existingItem.quantity > 1) {
        // Kalau masih ada quantity > 1, kurangi 1
        return {
          ...state,
          data: state.data.map((item) =>
            item.id === id ? { ...item, quantity: item.quantity - 1 } : item,
          ),
        };
      }

      // Kalau quantity = 1, hapus item
      return {
        ...state,
        data: state.data.filter((item) => item.id !== id),
      };
    }

    case types.CLEAR_CART:
      return {
        ...state,
        data: [],
      };

    default:
      return state;
  }
};

export default cartReducer;
